import { useFiltersContext } from '@/features/shop/components/ProductFilter/FiltersContext'
import { type SearchCategory } from '@/features/shop/services/Search/types'
import { findCurrentCategoryByParams } from '@/features/shop/services/Search/utils'
import { useSearchQueryParams } from '@/features/shared/hooks/search'

export const useCurrentCategory = (): SearchCategory | undefined => {
  const searchParams = useSearchQueryParams()
  const { facets } = useFiltersContext()
  if (!facets.length) return
  return findCurrentCategoryByParams(facets, searchParams)
}
